'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from 'lucide-react';
import Link from 'next/link';
import { Fragment } from 'react';
import { AchraTabIsotype } from '@/modules/home/components/build-network-section/achra-tab-isotype';
import { TextFlip } from '@/modules/shared/components/text-flip';
import { CtaDecorativeIsotype } from './cta-decorative-isotype';
import { CtaMeshBackground } from './cta-mesh-background';
function CtaBlock() {
  const $ = _c(9);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CtaMeshBackground />;
    t1 = <CtaDecorativeIsotype className="pointer-events-none absolute -top-16 -left-16 z-1 size-48 sm:-top-25 sm:-left-25 sm:size-50" />;
    t2 = <AchraTabIsotype variant="builders" isActive={true} className="relative z-1" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="text-foreground text-lg font-semibold tracking-tight">Get started</h3>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <br />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Fragment key="builder"><span className="font-normal">a</span> Builder</Fragment>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Fragment key="operator"><span className="font-normal">an</span> Operator</Fragment>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="relative z-1 flex flex-col gap-0.5">{t3}<p className="text-foreground max-w-[16rem] text-sm leading-snug">Begin your journey as {t4}{" "}<TextFlip words={[t5, t6, <Fragment key="organization"><span className="font-normal">an</span> Organization</Fragment>]} className="font-bold" /></p></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex h-full p-3"><Link href="/get-started" className="group focus-visible:ring-primary/30 relative isolate flex h-full min-h-[200px] w-full flex-col items-center justify-center gap-3 overflow-hidden rounded-2xl px-5 py-4 text-center transition-opacity hover:opacity-95 focus-visible:ring-[3px] focus-visible:outline-none sm:gap-4 sm:px-6">{t0}{t1}{t2}{t7}<span aria-hidden={true} className="text-foreground relative z-1 mt-0.5 flex size-10 shrink-0 items-center justify-center rounded-full bg-white shadow-sm transition-shadow group-hover:shadow-md group-focus-visible:shadow-md"><ArrowRight className="size-4" strokeWidth={2} /></span></Link></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}
export { CtaBlock };